import { useParams, Link, Navigate } from "react-router-dom";
import { FaCheckCircle, FaChartLine } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import { caseStudies } from "../data/blog";

export default function CaseSingle() {
  const { id } = useParams();
  const cs = caseStudies.find((c) => c.id === id);
  if (!cs) return <Navigate to="/case-studies" replace />;

  return (
    <>
      <PageHeader
        title={cs.title}
        crumbs={[{ label: "Case Studies", to: "/case-studies" }, { label: cs.title }]}
      />
      <section className="section">
        <div className="container single-layout reverse">
          <aside>
            <div className="sidebar-box">
              <h3>Project Details</h3>
              <table className="meta-table">
                <tbody>
                  <tr><td>Client</td><td>{cs.client}</td></tr>
                  <tr><td>Industry</td><td>{cs.industry}</td></tr>
                  <tr><td>Category</td><td>{cs.category}</td></tr>
                  <tr><td>Duration</td><td>{cs.duration}</td></tr>
                  <tr><td>Location</td><td>{cs.location}</td></tr>
                </tbody>
              </table>
            </div>
            <div className="sidebar-box" style={{ textAlign: "center" }}>
              <h3>Start Your Project</h3>
              <Link to="/contact-us" className="btn btn-primary btn-block">Get In Touch</Link>
            </div>
          </aside>

          <div className="single-content">
            <img src={cs.image} alt={cs.title} className="single-img" />
            <h2>The Challenge</h2>
            <ul className="check-list">
              {cs.challenges.map((c, i) => <li key={i}><FaCheckCircle /> {c}</li>)}
            </ul>

            <h2>Our Approach</h2>
            <p>{cs.approach}</p>

            <h2>The Solution</h2>
            <ul className="check-list">
              {cs.solutions.map((s, i) => <li key={i}><FaCheckCircle /> {s}</li>)}
            </ul>

            <h2>The Results</h2>
            <ul className="check-list">
              {cs.results.map((r, i) => <li key={i}><FaChartLine style={{ color: "var(--yellow)" }} /> {r}</li>)}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
